import { useState } from 'react';
import { Button } from 'ui';
import { useUser } from 'features/auth';
import ContactUsModal from './ContactUsModal';

type P = {
  onSuccess: (programId: string) => void;
  // TODO replace with `changeRequest` array once the real "requested to contact" state is modeled
  programData: {
    id: string;
    requestedToContact?: boolean;
  };
};

const ContactUs = ({ onSuccess, programData }: P) => {
  const [isContactUsModalOpened, setIsContactUsModalOpened] = useState(false);
  const onContactUsRequestSuccess = () => {
    onSuccess(programData.id);
    setIsContactUsModalOpened(false);
  };

  const { railsUserData: viewer } = useUser();

  return (
    <>
      {programData.requestedToContact ? (
        <Button disabled size="large" type="primary">
          Request sent
        </Button>
      ) : (
        <Button
          onClick={() => {
            setIsContactUsModalOpened(true);
          }}
          size="large"
          type="primary"
        >
          Contact us
        </Button>
      )}
      <ContactUsModal
        isOpened={isContactUsModalOpened}
        onClose={() => {
          setIsContactUsModalOpened(false);
        }}
        onSuccess={onContactUsRequestSuccess}
        programId={programData.id}
        userPhone={viewer.phone}
      />
    </>
  );
};

export default ContactUs;
